export class MessageColors
{
  static gray( text:string )
  {
    return text;
  }

  static yellow( text:string )
  {
    return text;
  }

  static black( text:string )
  {
    return text;
  }

  static bgRed( text:string )
  {
    return text;
  }
}